import React, { Component } from 'react'
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import SvgAddPButton from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';

const styles = (theme) => {
    return {
        layout: {
            transform: 'scale(0.85)',
            marginTop: '25px',
        },
    };
}

class AddButton extends Component {
    render() {
        const {classes} = this.props;

        return (
            <div className={classes.layout}>
                <Button
                    size='small'
                    onClick={this._handleOnClick}
                >
                        <SvgAddPButton/>
                </Button>
            </div>
        )
    }

    _handleOnClick = () => {
        if (this.props.onClick) {
            this.props.onClick(this.props.info);
        }
    }
}

AddButton.propTypes = {
    onClick: PropTypes.func,
}

export default withStyles(styles)(AddButton);
